// Components
import { BreadCrumb ,PaymentPageTab} from '../../components';

// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const CreatePaymentPage= ({ history }) => {
    const { location } = history;
    console.log("history : ", history);

    // useEffect(() => {
    //     if (location.pathname !== '/payment-page/create/Payment-page') {
    //         history.replace('/payment-page');
    //     }
    // }, [history, location.pathname]);

    return (
        <div className="create-merchant-wrap" id="create-merchant-section">
            <div className="bread-crumbs">
                <h3>Create PaymentPage</h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Payment Page',
                            link: '/payment-page',
                        },
                        {
                            name: 'Create Payment Page',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-merchant">
                <PaymentPageTab />
            </div>
        </div>
    );
};

CreatePaymentPage.propTypes = {
    history: PropTypes.object,
};

export default CreatePaymentPage;
